import { render, staticRenderFns } from "./SitePanel.vue?vue&type=template&id=47d56bd1&scoped=true"
import script from "./SitePanel.vue?vue&type=script&lang=js"
export * from "./SitePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d56bd1",
  null
  
)

export default component.exports